<script setup>
const props = defineProps({
  enabled: {
    type: Boolean,
    default: true,
  },
  withBackground: {
    type: Boolean,
    default: true,
  },
  pos: {
    type: Object,
    default: null,
  },
})

const x = ref(0)
const y = ref(0)
const el = ref(null)

function setPosition() {
  if (props.pos) {
    x.value = props.pos.x
    y.value = props.pos.y
    return
  }

  const parent = el.value.parentElement
  x.value = parent.clientWidth / 2 + parent.offsetLeft
  y.value = parent.clientHeight / 2 + parent.offsetTop
}

// Lifecycle
onMounted(() => {
  setPosition()
  window.addEventListener('resize', setPosition)
})

onBeforeUnmount(() => {
  window.removeEventListener('resize', setPosition)
})
</script>

<template>
  <div ref="el" class="pulse-beat" :class="{ 'pulse-beat--active': enabled }">
    <div
      v-if="withBackground"
      class="pulse-beat__background"
      :style="{
        left: `${x}px`,
        top: `${y}px`,
      }"
    />

    <div
      class="pulse-beat__ring pulse-beat__ring--0"
      :style="{
        left: `${x}px`,
        top: `${y}px`,
      }"
    />

    <div
      class="pulse-beat__ring pulse-beat__ring--1"
      :style="{
        left: `${x}px`,
        top: `${y}px`,
      }"
    />
  </div>
</template>

<style lang="scss">
@import 'styles/utils/timing-functions';
@import 'styles/utils/variables';

.pulse-beat {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  pointer-events: none;
  // overflow: hidden;

  &__background {
    background: radial-gradient(
      50% 50% at 50% 50%,
      #c80afb 0%,
      rgba(200, 10, 251, 0.63) 31.77%,
      rgba(200, 10, 251, 0.36) 60.94%,
      rgba(200, 10, 251, 0) 99.94%
    );
    width: 118px;
    height: 152px;
    position: absolute;
    transform: translate(-50%, -50%) rotate(84.5deg);
    opacity: 0.2;
  }

  &__ring {
    width: 5px;
    height: 5px;
    border-radius: 50%;
    border: 1px solid rgba($brand-magenta, 0.2);
    transform: translate(-50%, -50%);
    position: absolute;
  }

  &--active {
    .pulse-beat__ring {
      animation: 4s $ease-in-quart infinite scaleUp;

      &--1 {
        animation-delay: 0.3s;
      }
    }
  }
}

@keyframes scaleUp {
  0% {
    width: 0px;
    height: 0px;
    opacity: 1;
  }
  50% {
    opacity: 1;
  }
  100% {
    width: 100px;
    height: 100px;
    opacity: 0;
  }
}
</style>
